import React, { useState } from 'react';
import { FaFilePdf, FaChevronRight,FaEnvelope } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';
import '../styles/CodeReader.css';
// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';

import mainImage from '../assets/code-reader-main.png';
import tab1Image from '../assets/code-reader-tab1.jpg';
import tab2Image from '../assets/code-reader-tab2.jpg';
import tab3Image from '../assets/code-reader-tab3.jpg';

import CodeReaderMain from '../assets/Smart Code Reader.pdf';
import CodeReaderSpecification from '../assets/Code Reader Specification.pdf';
import RCD_AI_SERIES_Pdf from '../assets/INTELLIGENT-CODE-READER-RCD-AI-SERIES.pdf';
import RCD_AI100_S_series_Pdf from '../assets/INTELLIGENT-CODE-READER-RCD-AI100-S-series.pdf';
import RCD_AI500_C_SERIES_Pdf from '../assets/INTELLIGENT-CODE-READER-RCD-AI2000-C-RCD-AI500-C-SERIES.pdf';


import codeReaderSpecsImg from '../assets/Code Reader Specification IMG.jpg';


export default function CodeReader() {
  const [activeTab, setActiveTab] = useState('rcd-ai');
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="CodeReader-wrapper">
      <Header />

      <div className="hero-banner26">
        <div className="hero-banner26-content">
          <h1>CODE READER</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>Code Reader</span>
          </div>
        </div>
      </div>

      <section className="sensor-overview">
        <div className="sensor-img">
          <img src={mainImage} alt="Code Reader" />
        </div>
        <div className="sensor-text">
          <h2>Barcode Readers</h2>
          <ul>
            <li>Built-in megapixel image sensor combined with self-developed advanced sampling technology and millisecond-level decoding algorithm</li>
            <li>Easy to operate, one-click parameter adjustment, greatly saving debugging time</li>
            <li>Powerful networking function, supports 32 units to work together, and aggregates the data from the slave station to the master station for unified transmission</li>
            <li>Preset multiple sets of algorithms and imaging parameters for cyclic decoding, which can be compatible with bright and dark sound field conditions and product height difference scenes at the same time</li>
          </ul>
          <div className="sensor-buttons">
            <a href={CodeReaderMain}  target="_blank" rel="noopener noreferrer" style={{color:"white"}}>
              <button className="download-catalog-btn">
                <FaFilePdf /> Full Catalog Download
              </button>
            </a>
          <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
      {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

          </div>
        </div>
      </section>

      <div className="tab-headers">
        <button className={activeTab === 'rcd-ai' ? 'active' : ''} onClick={() => setActiveTab('rcd-ai')}>
          RCD-AI SERIES
        </button>
        <button className={activeTab === 'rcd-100' ? 'active' : ''} onClick={() => setActiveTab('rcd-100')}>
          RCD-AI100-S series
        </button>
        <button className={activeTab === 'rcd-2000' ? 'active' : ''} onClick={() => setActiveTab('rcd-2000')}>
          RCD-AI2000-C RCD-AI500-C SERIES
        </button>
          <button className={activeTab === 'specs' ? 'active' : ''} onClick={() => setActiveTab('specs')}>
    Technical Specifications
  </button>
      </div>

      <div className="sensor-tab-content">
        {activeTab === 'rcd-ai' && (
          <div className="sensor-tab-inner">
  <div className="sensor-tab-box">
    <img src={tab1Image} alt="RCD-AI Series" />
    <div className="sensor-tab-text">
      <h3>Intelligent Reader RCD-AI Series</h3>
      <ul>
        <li>Light Source: Non-polarized red light</li>
        <li>Protection Degree: IP67</li>
        <li>Focal Length: 8mm</li>
      </ul>
                <a href={RCD_AI_SERIES_Pdf}  target="_blank" rel="noopener noreferrer">
                  <button className="download-catalog-btn"><FaFilePdf />Download</button>
                </a>
    </div>
  </div>
</div>

        )}

{activeTab === 'rcd-100' && (
  <div className="sensor-tab-inner">
    <div className="sensor-tab-box">
      <img src={tab2Image} alt="RCD-AI100-S" />
      <div className="sensor-tab-text">
        <h3>Intelligent Reader RCD-AI 100-S Series</h3>
        <ul>
          <li>Light Source: Non-polarized red light</li>
          <li>Protection Degree: IP67</li>
          <li>Focal Length: 8mm</li>
        </ul>
                <a href={RCD_AI100_S_series_Pdf}  target="_blank" rel="noopener noreferrer">
                  <button className="download-catalog-btn"><FaFilePdf />Download</button>
                </a>
      </div>
    </div>
  </div>
)}
{activeTab === 'rcd-2000' && (
  <div className="sensor-tab-inner">
    <div className="sensor-tab-box">
      <img src={tab3Image} alt="RCD-AI2000 Series" />
      <div className="sensor-tab-text">
        <h3>Intelligent Reader RCD-AI Series</h3>
        <ul>
          <li>Light Source: Non-polarized red light</li>
          <li>Protection Degree: IP67</li>
          <li>Focal Length: 8mm</li>
        </ul>
                <a href={RCD_AI500_C_SERIES_Pdf}  target="_blank" rel="noopener noreferrer">
                  <button className="download-catalog-btn"><FaFilePdf />Download</button>
                </a>
      </div>
    </div>
  </div>
)}

{activeTab === 'specs' && (
  <div className="CodeReaderSpecs-image-wrapper">
    <img
      src={codeReaderSpecsImg} // OR import codeReaderSpecsImg from '../assets/...'
      alt="Code Reader Technical Specifications"
      className="CodeReaderSpecs-img"
    />
    <div className="CodeReaderSpecsa-download-btn">
      <a href={CodeReaderSpecification} target="_blank" rel="noopener noreferrer">
        <button className="download-catalog-btn">
          <FaFilePdf style={{ marginRight: '8px' }} /> Download
        </button>
      </a>
    </div>
  </div>
)}

      </div>

      <Footer />
    </div>
  );
}
